import { Link } from 'react-router-dom';
import { Mail, Instagram, Facebook } from 'lucide-react';
import { Input } from '../components/ui/input';
import { Button } from '../components/ui/button';
import { useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const Footer = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubscribe = async (e) => {
    e.preventDefault();
    if (!email) return;
    
    setLoading(true);
    try {
      await axios.post(`${API}/newsletter/subscribe`, { email });
      toast.success('Successfully subscribed to newsletter!');
      setEmail('');
    } catch (err) {
      toast.error('Failed to subscribe. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <footer className="bg-primary/85 text-primary-foreground">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand */}
          <div className="space-y-4">
            <Link to="/" className="inline-block">
              <img 
                src="https://customer-assets.emergentagent.com/job_72864342-79da-42e1-8892-f4c7769f68b7/artifacts/25zqc2g5_d.png" 
                alt="Circulate Travel" 
                className="h-20 w-auto brightness-110"
              />
            </Link>
            <p className="text-sm text-primary-foreground/70">
              We Plan, You Play! Curated travel experiences for adventurers who want hassle-free journeys.
            </p>
            <div className="flex gap-4">
              <a href="https://www.instagram.com/circulatetravel" target="_blank" rel="noopener noreferrer" className="text-primary-foreground/70 hover:text-secondary transition-colors" aria-label="Instagram">
                <Instagram className="h-5 w-5" />
              </a>
              <a href="https://www.facebook.com/circulatetravel" target="_blank" rel="noopener noreferrer" className="text-primary-foreground/70 hover:text-secondary transition-colors" aria-label="Facebook">
                <Facebook className="h-5 w-5" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-heading font-semibold mb-4">Explore</h4>
            <ul className="space-y-3">
              <li><Link to="/group-adventures" className="text-sm text-primary-foreground/70 hover:text-secondary transition-colors">Group Adventures</Link></li>
              <li><Link to="/solo-adventures" className="text-sm text-primary-foreground/70 hover:text-secondary transition-colors">Solo Adventures</Link></li>
              <li><Link to="/customize" className="text-sm text-primary-foreground/70 hover:text-secondary transition-colors">Customize Your Trip</Link></li>
              <li><Link to="/resources" className="text-sm text-primary-foreground/70 hover:text-secondary transition-colors">Travel Hub</Link></li>
              <li><Link to="/how-it-works" className="text-sm text-primary-foreground/70 hover:text-secondary transition-colors">How It Works</Link></li>
            </ul>
          </div>

          {/* Support */}
          <div>
            <h4 className="font-heading font-semibold mb-4">Support</h4>
            <ul className="space-y-3">
              <li><Link to="/faq" className="text-sm text-primary-foreground/70 hover:text-secondary transition-colors">FAQ</Link></li>
              <li><Link to="/contact" className="text-sm text-primary-foreground/70 hover:text-secondary transition-colors">Contact Us</Link></li>
              <li><Link to="/privacy" className="text-sm text-primary-foreground/70 hover:text-secondary transition-colors">Privacy Policy</Link></li>
              <li><Link to="/terms" className="text-sm text-primary-foreground/70 hover:text-secondary transition-colors">Terms of Service</Link></li>
            </ul>
          </div>

          {/* Newsletter */}
          <div>
            <h4 className="font-heading font-semibold mb-4">Stay Updated</h4>
            <p className="text-sm text-primary-foreground/70 mb-4">
              Get exclusive deals and travel inspiration delivered to your inbox.
            </p>
            <form onSubmit={handleSubscribe} className="flex gap-2">
              <Input
                type="email"
                placeholder="Enter your email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="bg-white/10 border-white/20 text-white placeholder:text-white/50"
                data-testid="footer-email-input"
              />
              <Button type="submit" disabled={loading} className="bg-secondary hover:bg-secondary/90" data-testid="footer-subscribe-btn">
                <Mail className="h-4 w-4" />
              </Button>
            </form>
          </div>
        </div>

        <div className="border-t border-white/10 mt-12 pt-8 text-center">
          <p className="text-sm text-primary-foreground/50">
            © {new Date().getFullYear()} Circulate Travel. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};
